import { Quill } from 'react-quill';

const BlockEmbed = Quill.import('blots/block/embed');

class VideoUploadBlot extends BlockEmbed {
  static blotName = 'videoUpload';
  static tagName = 'video';

  static create(url: string) {
    const node = super.create(url) as HTMLVideoElement;
    node.setAttribute('src', url);
    node.setAttribute('controls', '');
    node.setAttribute('style', 'max-width: 100%; display: block;');
    return node;
  }

  static value(node: HTMLElement) {
    return node.getAttribute('src');
  }
}

export default VideoUploadBlot;
